import React from "react"
import ArticleItem from "./article-item"
import { useStaticQuery, graphql } from "gatsby"
import { getSidebarEntries } from "../../../../templates/util"
const ArticleSection = ({ slug }) => {
  const data = useStaticQuery(graphql`
    {
      allMdx {
        nodes {
          slug
          fields {
            source
          }
          frontmatter {
            title
            order
          }
        }
      }
    }
  `)
  const metaData = [
    {
      
      para1:
        "Nitty-gritty technical descriptions of how Gatsby works. Most useful",
      title: "basic",
      para2: "when you need detailed information about Gatsby's APIs..",
    },
    {
      
      para1:
        "Nitty-gritty technical descriptions of how Gatsby works. Most useful",
      title: "advanced",
      para2: "when you need detailed information about Gatsby's APIs..",
    },
  ]
  const info = data.allMdx.nodes
  let defaultSideBarEntries = getSidebarEntries(
    info.filter(node => node.fields.source === "docs")
  )
  const slugParts = slug.split("/")
  const parent = slugParts[1]
  let currentEntries =
    slugParts.length === 1
      ? defaultSideBarEntries
      : defaultSideBarEntries.filter(el => {
          return el.text === parent
        })
  return (
    <div id="ArticleSection">
      {currentEntries[0].subItems.map((item, index) => {
       
        return (
          index > 0 && item.subItems.length > 0 && (
            <div className="py-2" key={index}>
              <ArticleItem data={item} metaData={metaData} />
            </div>
          )
        )
      })}
    </div>
  )
}

export default ArticleSection
